module.exports = __webpack_public_path__ + "static/05-MRI-Data-Points-Couple-Circle_1000x1000-4a089c6885c85621d1145f510d7f8739.jpg";